import { render, staticRenderFns } from "./publish-manager.vue?vue&type=template&id=01e38f38&scoped=true"
import script from "./publish-manager.vue?vue&type=script&lang=js"
export * from "./publish-manager.vue?vue&type=script&lang=js"
import style0 from "./publish-manager.vue?vue&type=style&index=0&id=01e38f38&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01e38f38",
  null
  
)

export default component.exports